// extracted by mini-css-extract-plugin
module.exports = {"situationPage":"SituationPage_situationPage__SdA8H","content":"SituationPage_content__9sDXx","pullUp":"SituationPage_pullUp__HGoDN"};